function postLeadSurveyService($http, modalService, $cookies, pageStateService, $controller) {

    let apigeeHost = null;
    let vdpApiKey = null;
    let surveyQuestions = null;
    let shadowSettingsProxy = null;
    let ctrlMethods = {};
    let modalActionsSet = false;
    let typModalController = $controller('typModalController');

    return {

        setProxyInfo(_host, _proxy, _apiKey) {
            apigeeHost = _host;
            vdpApiKey = _apiKey;
            shadowSettingsProxy = _proxy;
        },

        saveAnswer(answerType, answerValue) {
            let visitorCookie;
            const self = this;
            const answer = {
                type: answerType,
                value: answerValue
            };

            try {
                visitorCookie = JSON.parse($cookies.get('CarsVisitor')) || {};
            } catch (e) {
                visitorCookie = {};
            }

            let  url = `${apigeeHost}${shadowSettingsProxy}shadow-settings/?apikey=${vdpApiKey}`;

            return $http.put(url, {
                answers: [
                    answer
                ]
            }, {
                headers: {
                    'x-cars-device-id': visitorCookie.pdid || '',
                    'x-cars-consumer-id': visitorCookie.pcid || ''
                }
            }).then(function () {
                self.updateAnswerInMemory(answer);
            });
        },

        updateAnswerInMemory(answer) {
            const oldAnswerIndex = surveyQuestions.findIndex(function (oldAnswer) {
                return oldAnswer.type === answer.type;
            });

            if (oldAnswerIndex === -1) {
                surveyQuestions.push(answer);
            } else {
                surveyQuestions[oldAnswerIndex] = answer;
            }
        },

        loadCtrl(ctrl) {
            ctrlMethods = ctrl;
        },

        setSurveyQuestions(shadowSettings, bodyType) {
            if (!shadowSettings) {
                surveyQuestions = [];
            } else {
                let surveyQuestionsFiltered = [];
                if (bodyType && shadowSettings.questionsAndAnswers) {
                    bodyType = bodyType.toUpperCase().split(" ").join("_");
                    surveyQuestionsFiltered = shadowSettings.questionsAndAnswers.filter(answer => {
                        return (answer.tags.indexOf("VDP") !== -1) && (answer.tags.indexOf(bodyType) !== -1);
                    });
                } else if (shadowSettings.questionsAndAnswers) {
                    surveyQuestionsFiltered = shadowSettings.questionsAndAnswers.filter(answer => {
                        return answer.tags.indexOf("VDP") !== -1;
                    });
                }
                surveyQuestions = surveyQuestionsFiltered.slice(0,5).filter(question => question.value === null);
            }
        },

        setModalActions(options, override) {
            if (!modalActionsSet || override) {
                let modal = modalService.get('postLeadSurvey');
                if (typeof options.beforeClose == 'function') {
                    modal.beforeClose(options.beforeClose);
                }
                if (typeof options.beforeOpen == 'function') {
                    modal.beforeOpen(options.beforeOpen);
                }
                modalActionsSet = true;
            }
        },

        openSurveyModal(shadowSettings, bodyType, skipThankYouModal, dtmPageName) {
            this.setSurveyQuestions(shadowSettings, bodyType);

            ctrlMethods.onOpen(surveyQuestions);
            ctrlMethods.setVdpVariables(skipThankYouModal);
            typModalController.setupTYModalPageData();

            const unAnsweredCount = surveyQuestions.reduce(function (sum, question) {
                if (question.value === null) {
                    return sum + 1;
                } else {
                    return sum;
                }
            }, 0);

            if (unAnsweredCount > 0) {
                this.setModalActions({
                    beforeOpen: () => {
                        /* istanbul ignore next */
                        if (dtmPageName) {
                            pageStateService.push('page.pageInfo.pageName', dtmPageName, false);
                            pageStateService.push('page.pageInfo.channel', 'leads', false);
                        }
                    },
                    beforeClose: () => {
                        /* istanbul ignore next */
                        pageStateService.pop('page.pageInfo.pageName', false);
                        pageStateService.pop('page.pageInfo.channel', false);
                        pageStateService.push('event', { eventName: 'modal-close' }, true);
                    }
                }, false);
                modalService.get('postLeadSurvey').toggle();
            } else {
                if (skipThankYouModal) {
                    modalService.closeAll();
                } else {
                    modalService.get('typModal').toggle();
                }
            }
        }
    };
}

postLeadSurveyService.$inject = [
    '$http',
    'modalService',
    '$cookies',
    'pageStateService',
    '$controller'
];

export default postLeadSurveyService;
